// TODO: MNS-2738 - Can be removed after the entire create order form is migrated to React.
import { LocationAndTimeForm } from './LocationAndTimeForm'

export default LocationAndTimeForm
